import React from 'react'
import { StickyContent } from 'marketing-site/src/library/components/StickyContent'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { CONTENT_TYPE, IStickyContent } from 'marketing-site/@types/generated/contentful'
import { useBrand } from 'marketing-site/src/library/providers/brandProvider'

export const ContentfulStickyContent = (stickyContent: IStickyContent) => {
  const brand = useBrand()
  const content = stickyContent.fields.content.map((contentItem: any) => {
    return renderTransformedComponent(
      contentItem.sys.contentType.sys.id as CONTENT_TYPE,
      contentItem,
      undefined,
      brand,
    )
  })
  const { contentPosition } = stickyContent.fields
  return (
    <StickyContent
      {...stickyContent.fields}
      marginBottom={'-80%'}
      threshold={0}
      contentPosition={contentPosition}
    >
      {content}
    </StickyContent>
  )
}
